import React from 'react';
import BaseSkeleton from './base-skeleton';

interface SkeletonAvatarProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const sizeMap = {
  sm: 'w-8 h-8',
  md: 'w-10 h-10',
  lg: 'w-12 h-12',
  xl: 'w-16 h-16',
};

const SkeletonAvatar: React.FC<SkeletonAvatarProps> = ({ size = 'md', className = '' }) => {
  return (
    <BaseSkeleton
      variant="circular"
      className={`${sizeMap[size]} ${className}`}
      width="100%"
      height="100%"
    />
  );
};

export default SkeletonAvatar;